import TabComp from '@material-ui/core/Tab';
import TabsComp from '@material-ui/core/Tabs';
import {
  MOON_200,
  MOON_650,
  MOON_800,
  TEAL_500,
} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const JobTableTabs = styled(TabsComp)`
  box-shadow: inset 0 -2px 0 0 ${MOON_200};
  margin-bottom: 16px;
  .MuiTabs-indicator {
    background-color: ${TEAL_500};
  }
`;

export const JobTableTab = styled(TabComp)`
  && {
    min-width: 0;
    font-size: 16px;
    margin-left: 0;
    margin-right: 32px;
    padding: 0;
    line-height: 32px;
    font-weight: 600;
    color: ${MOON_650};
    opacity: 1;
    &:hover,
    &:active {
      color: ${MOON_800};
    }
    &.Mui-selected {
      color: ${MOON_800};
    }
  }
`;
